import { render, staticRenderFns } from "./PatientsSearch.vue?vue&type=template&id=9ad44748&scoped=true&"
import script from "./PatientsSearch.vue?vue&type=script&lang=js&"
export * from "./PatientsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad44748",
  null
  
)

export default component.exports